import {
  ROOT,
  UPDATE_BULK,
  UPDATE_ROOM_AVAIL,
  GET_ALL_USERS,
  GET_ALL_ROOMS,
  GET_ALL_ACTIVITY,
  GET_ALL_ROOM_PLANS,
  GET_DETAIL,
  GET_DETAIL_ROOM_LOG
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAllUpdateBulk(params) {
  return fetch(ROOT + UPDATE_BULK, requestOptions.post(params)).then(
    handleResponse
  );
}

function getAllUpdateRoomAvail(params) {
  return fetch(ROOT + UPDATE_ROOM_AVAIL, requestOptions.post(params)).then(
    handleResponse
  );
}

function getUserName() {
  return fetch(ROOT + GET_ALL_USERS, requestOptions.get()).then(handleResponse);
}

function getAllRoom() {
  return fetch(ROOT + GET_ALL_ROOMS, requestOptions.get()).then(handleResponse);
}

function getAllRoomPlan(params) {
  return fetch(
    ROOT + GET_ALL_ROOM_PLANS + `/` + params,
    requestOptions.get()
  ).then(handleResponse);
}

function getAllActivity(params) {
  return fetch(ROOT + GET_ALL_ACTIVITY, requestOptions.post(params)).then(
    handleResponse
  );
}
function getDetail(params) {
  return fetch(ROOT + GET_DETAIL, requestOptions.post(params)).then(
    handleResponse
  );
}
function getDetailRoomLog(params) {
  return fetch(ROOT + GET_DETAIL_ROOM_LOG, requestOptions.post(params)).then(
    handleResponse
  );
}


export const service = {
  getAllUpdateBulk,
  getAllUpdateRoomAvail,
  getUserName,
  getAllRoom,
  getAllRoomPlan,
  getAllActivity,
  getDetail,
  getDetailRoomLog
};
